export function ShowCustomAlert(message: string, title = "Notification"): void {
    let modal = document.getElementById("customAlert") as HTMLElement | null;

    // If the modal doesn't exist in the DOM, create and append it
    if (!modal) {
        modal = document.createElement("div");
        modal.id = "customAlert";
        modal.className = "hidden fixed inset-0 bg-opacity-50 backdrop-blur-md overflow-y-auto h-full w-full flex items-center justify-center z-50";

        modal.innerHTML = `
            <div class="relative p-5 w-96 bg-white rounded-lg shadow-lg">
                <h3 id="alertTitle" class="text-lg font-medium text-gray-900 mb-2"></h3>
                <p id="alertMessage" class="text-sm text-gray-700"></p>
                <div class="mt-4 flex justify-end">
                    <button id="alertCloseBtn" class="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600">OK</button>
                </div>
            </div>
        `;

        document.body.appendChild(modal);

        // Attach event listener to close button
        const alertCloseBtn = document.getElementById("alertCloseBtn") as HTMLElement;
        alertCloseBtn.onclick = () => {
            modal?.classList.add("hidden");
        };
    }

    // Update modal content dynamically
    const alertTitle = document.getElementById("alertTitle") as HTMLElement;
    const alertMessage = document.getElementById("alertMessage") as HTMLElement;
    alertTitle.textContent = title;
    alertMessage.innerHTML = message.replace(/\n/g, "<br>");

    // Show the modal
    modal.classList.remove("hidden");

    // Auto-hide after 3 seconds
    setTimeout(() => {
        modal?.classList.add("hidden");
    }, 5000);
}